import { Tabs } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import FormControlContainer from './FormControlContainer';
import { TTabsControlConnectorProps } from './FormTabsControlContainer';
import { useFormGroupErrors } from './useFormGroupErrors';

const FormTabsControl: React.FC<TTabsControlConnectorProps> = ({
  control,
  childAuxProps,
  formId,
}) => {
  const { errors } = useFormGroupErrors(formId, control.name);

  return (
    <Tabs syncHeight={true} className="col-12">
      {control.children.map(child => {
        const isWarning = childAuxProps[child].warning || errors.has(child);
        return (
          <Tabs.Pane
            key={child}
            name={child}
            hidden={childAuxProps[child].hidden}
            label={childAuxProps[child].label}
            badgeSx={isWarning ? { minHeight: 6, minWidth: 6 } : undefined}
          >
            <FormControlContainer formId={formId} key={child} name={child} />
          </Tabs.Pane>
        );
      })}
    </Tabs>
  );
};

export default FormTabsControl;
